import { render, staticRenderFns } from "./waybillLogList.vue?vue&type=template&id=1a0f6764&scoped=true&"
import script from "./waybillLogList.vue?vue&type=script&lang=js&"
export * from "./waybillLogList.vue?vue&type=script&lang=js&"
import style0 from "./waybillLogList.vue?vue&type=style&index=0&id=1a0f6764&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f6764",
  null
  
)

export default component.exports